import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { CommonService } from './../common.service';
import { CommonVariablesService } from './../common-variables.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
})

export class ChangePasswordComponent implements OnInit 
{
  changePasswordForm: FormGroup;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any;
  submitted=false;
  oldPassword:any;
  newPassword:any;
  confirmPassword:any;
  parameter:any;
  response:any;
  
  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private commonVariablesService: CommonVariablesService
  ) { }

  ngOnInit() 
  {
	  window.localStorage.setItem('pageName','');
    this.changePasswordForm =this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required,Validators.pattern('^(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,}$')]],
      confirmPassword:['', Validators.required]
     })
  }
  
  get f() { return this.changePasswordForm.controls; }
  
  /*
  * Created By : Keerthana
  * Description : This function will change the password.
  *********************************************/

  async changePassword()
  {
    this.submitted=true;
    if (this.changePasswordForm.invalid) 
    {
      return;
    }
    else
    { 
      this.oldPassword=this.changePasswordForm.controls.oldPassword.value;
      this.newPassword=this.changePasswordForm.controls.newPassword.value;
      this.confirmPassword=this.changePasswordForm.controls.confirmPassword.value;
      if(this.oldPassword!= this.newPassword)
      {
        if(this.newPassword==this.confirmPassword)
        {
          var url = this.commonVariablesService.baseURL+'api/v1/profile/change_password' ;
        
          this.parameter ={
            old_password:this.oldPassword,
            new_password: this.newPassword
          }
          this.response = await this.commonService.httpPostMethod(url,this.parameter,'application/json',true,'Change Password')
          
          if(this.response.body.status == 0)
          {
            this.commonService.successmsg('Password Changed Successfully','Success');
            this.resetForm();
          }
          else if(this.response.body.status !=-114)
          {
            this.commonService.errorsmsg('Unable to change password','Error');
          }
        }
        else
        {
          this.commonService.errorsmsg('New Password and Confirm Password should be same','Error');
        }
      }
      else
      {
        this.commonService.errorsmsg('Old Password and New Password should be differnet','Error');
      }
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function is used to reset the form.
  *********************************************/
 
  resetForm()
  {
    this.changePasswordForm.reset();
    this.submitted = false;
  }
}
